// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"settings_settingsWrapper__14GYP","settingsHeader":"settings_settingsHeader__ab6mr"};